<template>
    <div>
        <el-dialog
            class="attachment receipt-signattachment"
            :title="titlePicture"
            :visible.sync="diaShaow"
            :before-close="handleStartClose"
            :close-on-click-modal="false"
            width="50%"
        >
            <div class="attachment-title"></div>
            <div class="attachment-left">
                <div class="pictures-content">
                    <ul id="viewers" class="viewers-c">
                        <li class="imglists">
                            <img
                                :src="imgUrl"
                                class="imgshow"
                            />
                        </li>
                    </ul>
                </div>
            </div>
            <div slot="footer" class="dialog-footer"></div>
        </el-dialog>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    props: {
        imgUrl: {
            type: String,
            default: ''
        },
        diaShaow: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object
        },
        titlePicture: {
            type: String
        }
    },
    data() {
        return {};
    },
    methods: {
        handleStartClose() {
            this.$emit('handleStartClose', {
                data: this.data
            });
        },
        updateViewer() {
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        initViewer() {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: false,
                button: true,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    reset: barOptions,
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initViewer();
        });
    },
    beforeDestroy() {
        this.viewer.destroy();
    }
};
</script>

<style lang="less">
@import './Picture.less';
</style>
